import React from 'react';
import Form from 'react-bootstrap/Form';
import i18n from 'i18n';
import FormHelp from '@/components/forms/FormHelp';

interface ActionWebhookFormFieldsProps {
    formik: any;
}

const ActionWebhookFormFields: React.FC<ActionWebhookFormFieldsProps> = React.memo((
    {
        formik,
    },
) => {

    return (
        <Form.Group className="mb-3" controlId="params.url" >
            <Form.Label>
                {i18n.t('jt_webhook_url.text')}
                <FormHelp content={i18n.t('jt_enter_valid.text')} placement="top" />
            </Form.Label>
            <Form.Control
                type="text"
                name="params.url"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.params.url || ''}
                isInvalid={formik.touched.params?.url && !!formik.errors.params?.url}
                data-cy="action-url-input"
            />
            <Form.Control.Feedback type="invalid">
                {formik.errors.params?.url}
            </Form.Control.Feedback>
        </Form.Group >
    );
});


export default ActionWebhookFormFields; 